class SiteStyle 
    extends QueryElement<HTMLStyleElement> {

    private _sheet: CSSStyleSheet;
    private _meta: IQueryElement;
    private __rules: number = 0;

    constructor(parent: IQueryElement) {
        super(document.createElement("style"));

        this.appendTo(parent);
        let element = this.get();
        if (element === null)
            throw "Could not find element.";

        let meta = new Query("meta[name=theme-color]").first();
        if(meta === null)
            throw 'Meta not found!';

        this._sheet = element.sheet as CSSStyleSheet;
        this._meta = meta;
    }
    addCss(css: string) {
        this._sheet.insertRule(css);
    }
    addColor(instance: number, color: string) {
        this._sheet.insertRule('#containers .container[data-instance="'+instance+'"] { --default-color: '+color+';}', this.__rules);
        this.__rules++;
    }
    setColor(color: string) {
        this._meta.setAttr("content", color);
    }
}